import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab';

const Container = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
`;

const Group = styled.div`
  display: flex;
  background-color: ${tokens.color_background_3_le};
  padding: 6px;
  border-radius: 30px;
`;

const GroupTitle = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  color: ${tokens.color_text_subtle_le};
`;

const ToggleGroup = ({
  children,
  name,
  onChange,
  defaultValue,
  title,
  style,
  titleStyle,
  disabled,
}) => {
  return (
    <Container style={style}>
      <GroupTitle style={titleStyle}>{title}</GroupTitle>
      <Group>
        {React.Children.map(children, (child) =>
          React.cloneElement(child, {
            name,
            onChange,
            defaultChecked: defaultValue === child.props.value,
            disabled,
          }),
        )}
      </Group>
    </Container>
  );
};

ToggleGroup.propTypes = {
  children: PropTypes.node.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  titleStyle: PropTypes.object,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

ToggleGroup.defaultProps = {};

export default ToggleGroup;
